import { Box, Typography } from '@mui/material';

import { AddressDate, FancyWrapper, PersonalInfoContentWrapper } from '@styles/ContactManager/HeaderStyles';
import { BorderWrapper, PersonalInfoDob, PersonalInfoName } from '@styles/CommonStyles';

import { SectionTitle } from '@shared/components/SectionTitle';
import { IPersonalInformation } from './interfaces/interfaces';

export const PersonalInfo = ({ personalInformation }: IPersonalInformation) => (
  <Box marginBottom={2}>
    <SectionTitle title="Personal Information" fontWeight={600} />

    <BorderWrapper marginBottom={2}>
      <PersonalInfoContentWrapper>
        <PersonalInfoName>
          <Typography variant="h4">Name</Typography>
          <div>{personalInformation?.name}</div>
        </PersonalInfoName>
        <div style={{ width: '50%' }}>
          <PersonalInfoDob>
            <Typography variant="h4">Date of Birth</Typography>
            <div>{personalInformation?.dataOfBirth}</div>
          </PersonalInfoDob>
        </div>
      </PersonalInfoContentWrapper>

      {personalInformation?.addresses?.map((address, index) => {
        return (
          <FancyWrapper key={index}>
            <PersonalInfoContentWrapper>
              <Box sx={{ width: '29%' }}>
                <Typography variant="h4">Address</Typography>
              </Box>

              <Box sx={{ width: '70%' }}>{address.address}</Box>
            </PersonalInfoContentWrapper>

            <AddressDate>
              <Box sx={{ width: '29%' }}>
                <Typography variant="h4">Reported On</Typography>
              </Box>

              <Box sx={{ width: '70%' }}>{address.reportedDate}</Box>
            </AddressDate>
          </FancyWrapper>
        );
      })}

      <FancyWrapper>
        <PersonalInfoContentWrapper>
          <div style={{ width: '50%' }}>
            <Typography variant="h4">AKA</Typography>
          </div>
          <div style={{ width: '50%' }}>
            <Typography variant="h4">SSN: {personalInformation?.ssn}</Typography>
          </div>
        </PersonalInfoContentWrapper>
      </FancyWrapper>

      <Box sx={{ padding: '5px 10px' }}>{personalInformation?.aka?.map((aka, index) => <div key={index}>{aka}</div>)}</Box>
    </BorderWrapper>
  </Box>
);
